import type { StaticImageData } from 'next/image';

import mandarakeLogoImage from '~/public/assets/images/mandarake_logo_image_4x.webp';
import mandarakeTopBanner from '~/public/assets/images/mandarake_top_image_4x.webp';
import mandarakeEntryCardImage from '~/public/assets/images/mandarake_entry_card_image.webp';
import ragTagLogoImage from '~/public/assets/images/ragtag_logo_image_4x.webp';
import ragTagTopBanner from '~/public/assets/images/ragtag_top_image_4x.webp';
import ragTagEntryCardImage from '~/public/assets/images/ragtag_entry_card_image.webp';
import surugayaLogoImage from '~/public/assets/images/surugaya_logo_image_4x.webp';
import surugayaTopBanner from '~/public/assets/images/surugaya_top_image_4x.webp';
import surugayaEntryCardImage from '~/public/assets/images/surugaya_entry_card_image.webp';

export const SHOP_IDS = {
  RAGTAG: 'TPNJQT6BXAcwCrXC4nTmu9',
  MANDARAKE: 'd2uUKgmbjTGT7BzBGUnXxe',
  SURUGAYA: 'YoUQXX6TT8X6C47LxjRZbH',
} as const;
export type ShopId = (typeof SHOP_IDS)[keyof typeof SHOP_IDS];

export interface ShopInfo {
  id: ShopId;
  /** 결제 안내 등에 쓰는 판매자 표기 */
  sellerName: string;
  shopNameKor: string;
  shopNameEng: string;
  /** 상점 카드 등에 쓰는 한 줄 설명 */
  shortDesc: string;
  /** 상품 상세 상점 진입 배너 문구. `shopNameKor` 가 강조 표시됨 */
  bannerDesc: string;
  /** 상점 페이지 소개글 */
  about: string;
  /** 푸터의 판매자 안내 문구. 없으면 개인 판매자 기본 문구 */
  footerSellerText?: string;
  /** 홈 상점 카드의 NEW 뱃지 노출 여부 */
  isNew?: boolean;
  images: {
    logo: StaticImageData;
    topBanner: StaticImageData;
    entryCard: StaticImageData;
  };
}

/**
 * 상점 추가 시 여기에 한 항목을 추가한다 (SEO 문구는 `shop-seo.ts` 에도 추가).
 * 홈 상점 카드 노출 순서 = 이 객체의 선언 순서.
 */
export const SHOPS: Record<ShopId, ShopInfo> = {
  [SHOP_IDS.SURUGAYA]: {
    id: SHOP_IDS.SURUGAYA,
    sellerName: '스루가야(SURUGAYA)',
    shopNameKor: '스루가야',
    shopNameEng: 'SURUGAYA',
    shortDesc: '최다 매물 TCG 샵',
    bannerDesc: '일본 최다 TCG 매물 샵, 스루가야 상품입니다',
    about:
      '스루가야(SURUGAYA)는 게임, 애니, 트레이딩 카드까지 아우르는 중고 취미용품 전문 스토어입니다. 특히 포켓몬, 원피스 등 인기 일본판 카드를 싱글카드부터 박스까지 다량의 매물을 보유하며, TCG 컬렉터들에게 꾸준한 사랑을 받고 있습니다.',
    isNew: true,
    images: { logo: surugayaLogoImage, topBanner: surugayaTopBanner, entryCard: surugayaEntryCardImage },
  },
  [SHOP_IDS.RAGTAG]: {
    id: SHOP_IDS.RAGTAG,
    sellerName: '래그태그(ragTag)',
    shopNameKor: '래그태그',
    shopNameEng: 'RAGTAG',
    shortDesc: '빈티지/셀렉트 샵',
    bannerDesc: '일본 빈티지/셀렉트 샵, 래그태그 상품입니다',
    about:
      '래그태그(RAGTAG)는 1985년, 일본 패션의 중심지 도쿄 하라주쿠에서 시작된 중고 디자이너 브랜드 전문 스토어입니다. 꼼꼼한 품질 관리를 거친 프리미엄 브랜드의 중고 의류, 가방, 신발, 액세서리 등을 합리적인 가격에 선보이며, 감각 있는 패션 애호가들에게 꾸준한 사랑을 받고 있습니다.',
    images: { logo: ragTagLogoImage, topBanner: ragTagTopBanner, entryCard: ragTagEntryCardImage },
  },
  [SHOP_IDS.MANDARAKE]: {
    id: SHOP_IDS.MANDARAKE,
    sellerName: '만다라케(mandarake)',
    shopNameKor: '만다라케',
    shopNameEng: 'Mandarake',
    shortDesc: '최대 서브컬쳐 샵',
    bannerDesc: '일본 최대 서브컬쳐 편집샵, 만다라케 상품입니다',
    about:
      '만다라케는 일본을 대표하는 세계 최대 서브컬처 상점 중 하나로, 빈티지 피규어, 프라모델, 애니메이션, 만화, 게임 등 백만여 개 이상의 다양하고 유니크한 수집품을 판매합니다.',
    footerSellerText: '본 상품은 만다라케(mandarake) 상품으로',
    images: { logo: mandarakeLogoImage, topBanner: mandarakeTopBanner, entryCard: mandarakeEntryCardImage },
  },
};

export const VALID_SHOP_IDS: ShopId[] = Object.values(SHOP_IDS);
